<template>
    <div class="modal fade" id="transferResultsModal" tabindex="-1" aria-labelledby="transferResultsModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="transferResultsModalLabel">Transmit all students results</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="loading" class="text-center my-4">
              <div class="spinner-border" role="status">
                <span class="sr-only">&nbsp;&nbsp;Transmitting...</span>
              </div>
            </div>
            <div v-else>
                <p>This action will transmit results of all students and save them into IS MUNI PA036 block.<B>Mind you set correct IS API KEY to environment variable BLOCK_API_KEY in docker-compose.yaml.</b></p>
                <p>It will overwrite all previous results in IS MUNI block.</p>
                <p>Transmitting results for all students could take some time.</p>
              <hr>
              <div class="mb-3">
                <p>Check CSV of data that will be transmitted:</p>
                <button type="button" @click="generateAndShowCSVResults" class="btn btn-primary btn-sm mx-1" :disabled="isGeneratingCSV">
                  <span v-if="isGeneratingCSV" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span v-if="isGeneratingCSV">Generating CSV ...</span>
                    <span v-else>View CSV</span>
                </button>
                <button type="button" @click="generateAndDownloadCSV" class="btn btn-success btn-sm mx-1" :disabled="isGeneratingCSV">
                  <span v-if="isGeneratingCSV" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span v-if="isGeneratingCSV">Generating CSV ...</span>
                  <span v-else>Download CSV</span>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="transferResultsForAllStudents" :disabled="isTransferingAll">
              <span v-if="isTransferingAll" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span v-else>Transmit Results</span>
            </button>
          </div>
        </div>
      </div>
    </div>

  <StemErrorModal ref="stemErrorModal"/>
  </template>
  
  <script>
  import StudentController from '@/controllers/StudentController';
  import StemErrorModal from './StemErrorModal.vue';
  import { Modal } from 'bootstrap';

  export default {
    name: 'TransferResultsModal',
    components: {
      StemErrorModal
    },
    data() {
      return {
        isTransferingAll: false,
        isGeneratingCSV: false,
      };
    },
    methods: {
      async transferResultsForAllStudents() {
        try {
          if (confirm(
              'This action overwrites results of all students in IS MUNI block. \n' +
              'Do you want to proceed?'
            )) {
              this.isTransferingAll = true;
              const response = await StudentController.transferResultsForAllStudents();
              
              // Manually hide the modal on success
              const modalElement = document.getElementById('transferResultsModal');
              const modalInstance = Modal.getInstance(modalElement);
              if (modalInstance) {
                modalInstance.hide();
              }
              
              if (response && response.length > 0) {
                // Show warning message with not found students
                this.$store.dispatch('triggerAlert', {
                  type: 'warning',
                  title: 'Warning',
                  message: 'Data transmit not completed for students: ' + response.join(', ')
                });
              } else {
                this.$store.dispatch('triggerAlert', {
                  type: 'success',
                  title: 'Success',
                  message: 'Data transmit completed successfully.'
                });
              }
          }
        } catch (error) {
          this.$refs.stemErrorModal.show('Error', error.message);
        } finally {
          this.isTransferingAll = false;
        }
      },
      async generateAndShowCSVResults() {
        try {
          this.isGeneratingCSV = true;
          const csvData = await StudentController.generateAndDownloadCSV();
          // open file in new tab
          window.open(URL.createObjectURL(new Blob([csvData.data])));
        } catch (error) {
          this.$refs.stemErrorModal.show('Error', error.message);
        }
        finally {
          this.isGeneratingCSV = false;
        }
      },
      async generateAndDownloadCSV() {
        try {
          this.isGeneratingCSV = true;
          const csvData = await StudentController.generateAndDownloadCSV();
          const url = window.URL.createObjectURL(new Blob([csvData.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', "transmitted_results.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          this.$refs.stemErrorModal.show('Error', error.message);
        }
        finally {
          this.isGeneratingCSV = false;
        }
      }
    },
  };
  </script>